// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderStatus-orderStatusBoxTopRadius-XlTmc {
    border-radius: var(--radius-3) var(--radius-3) 0 0;
}

.OrderStatus-orderStatusBoxBottomRadius-hOW2A {
    border-radius: 0 0 var(--radius-3) var(--radius-3);
}

.OrderStatus-orderStatusTrackBox-DhSHB {
    display: grid;
    grid-template-columns: 28px 1fr;
    gap: 12px;
    grid-gap: 12px;
    padding-bottom: 24px;
    position: relative;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    isolation: isolate;
}

.OrderStatus-orderStatusTrackBox-DhSHB:last-child::after {
    display: none;
}

.OrderStatus-orderStatusTrackBox-DhSHB:last-child {
    padding-bottom: 0;
}

.OrderStatus-orderStatusTrackBox-DhSHB::after {
    content: '';
    position: absolute;
    top: 14px;
    left: 14px;
    border-left: 1px dashed var(--primary-border);
    height: calc(100% - 14px);
    z-index: -1;
}

.OrderStatus-completedStatus-ps1mL::after {
    border-left: 1px dashed var(--primary-bg) !important;
}

.OrderStatus-completedStatus-ps1mL:last-of-type::after {
    display: none;
}

.OrderStatus-orderStatusContent-eZydg {
    margin-top: 3px;
}

.OrderStatus-orderStatusTrackImgContainer-BtqYq {
    position: relative;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    z-index: 1;
}

.OrderStatus-orderStatusTrackImg-beFfi {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

.OrderStatus-orderStatusCancelBookingContainer-UjFIH {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 12px;
}

@media (max-width: 767px) {
    .OrderStatus-orderStatusCancelBookingContainer-UjFIH {
        margin-top: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/OrderStatus/OrderStatus.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,6CAA6C;IAC7C,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".orderStatusBoxTopRadius {\n    border-radius: var(--radius-3) var(--radius-3) 0 0;\n}\n\n.orderStatusBoxBottomRadius {\n    border-radius: 0 0 var(--radius-3) var(--radius-3);\n}\n\n.orderStatusTrackBox {\n    display: grid;\n    grid-template-columns: 28px 1fr;\n    gap: 12px;\n    grid-gap: 12px;\n    padding-bottom: 24px;\n    position: relative;\n    align-items: flex-start;\n    isolation: isolate;\n}\n\n.orderStatusTrackBox:last-child::after {\n    display: none;\n}\n\n.orderStatusTrackBox:last-child {\n    padding-bottom: 0;\n}\n\n.orderStatusTrackBox::after {\n    content: '';\n    position: absolute;\n    top: 14px;\n    left: 14px;\n    border-left: 1px dashed var(--primary-border);\n    height: calc(100% - 14px);\n    z-index: -1;\n}\n\n.completedStatus::after {\n    border-left: 1px dashed var(--primary-bg) !important;\n}\n\n.completedStatus:last-of-type::after {\n    display: none;\n}\n\n.orderStatusContent {\n    margin-top: 3px;\n}\n\n.orderStatusTrackImgContainer {\n    position: relative;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    z-index: 1;\n}\n\n.orderStatusTrackImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}\n\n.orderStatusCancelBookingContainer {\n    display: flex;\n    margin-top: 12px;\n}\n\n@media (max-width: 767px) {\n    .orderStatusCancelBookingContainer {\n        margin-top: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderStatusBoxTopRadius": `OrderStatus-orderStatusBoxTopRadius-XlTmc`,
	"orderStatusBoxBottomRadius": `OrderStatus-orderStatusBoxBottomRadius-hOW2A`,
	"orderStatusTrackBox": `OrderStatus-orderStatusTrackBox-DhSHB`,
	"completedStatus": `OrderStatus-completedStatus-ps1mL`,
	"orderStatusContent": `OrderStatus-orderStatusContent-eZydg`,
	"orderStatusTrackImgContainer": `OrderStatus-orderStatusTrackImgContainer-BtqYq`,
	"orderStatusTrackImg": `OrderStatus-orderStatusTrackImg-beFfi`,
	"orderStatusCancelBookingContainer": `OrderStatus-orderStatusCancelBookingContainer-UjFIH`
};
module.exports = ___CSS_LOADER_EXPORT___;
